import Vue from 'vue';
import BaseLayout from './Layout';

const Layout = Vue.extend({
    ...BaseLayout,
    watch: {
        $route(to) {
            const matched = to.matched && to.matched[0];
            const name = to.meta.layout || matched && matched.meta.layout || 'fullscreen';
            this.setLayout(name);
        }
    }
});

export {
    Layout
};
